import {
  GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery,
  HospitalSortType,
} from '@/types/bff/gql-schema';
import { SearchHospitalVo } from '@/types/hospital';
import { getDiagnosisStateOfOperatingStatus, getFormattedReviewTotalCount, getReviewScore } from '@/utils/format';
import useGetKeywordSearchHospitalInfiniteQuery from './useGetKeywordSearchHospitalInfiniteQuery';

interface Props {
  keyword: string;
  latitude: number;
  longitude: number;
  size?: number;
  enabled?: boolean;
}

const HOSPITAL_SIZE = 50;

const parseSearchResultHospitalVo = (
  data: Array<GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery>
): Array<SearchHospitalVo> => {
  if (data) {
    return data
      .flatMap((page) => page.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.elements)
      .map((hospital) => {
        return {
          ...hospital,
          hospitalTotalCount: 0,
          hospitalRepresentativeDepartmentName: hospital?.hospitalRepresentativeDepartmentName || '',
          reviewScore: getReviewScore(hospital.reviewAverageRating),
          reviewCount: getFormattedReviewTotalCount(hospital.reviewTotalCount),
          hospitalOperationStatus: getDiagnosisStateOfOperatingStatus(hospital.hospitalOperationStatus),
          doctors: hospital.doctors.filter((doctor) => !!doctor),
        };
      });
  }
  return [] as Array<SearchHospitalVo>;
};

const useGetKeywordSearchHospitalInfinite = ({
  keyword,
  latitude,
  longitude,
  size = HOSPITAL_SIZE,
  enabled = true,
}: Props) => {
  const {
    data: hospitalData,
    isLoading: isHospitalLoading,
    hasNextPage: hasHospitalNextPage,
    fetchNextPage: fetchHospitalNextPage,
  } = useGetKeywordSearchHospitalInfiniteQuery(
    {
      request: {
        keyword,
        size,
        sortType: HospitalSortType.Distance,
        geoPoint: {
          latitude,
          longitude,
        },
      },
    },
    {
      select: (data) => {
        return {
          pages: parseSearchResultHospitalVo(data.pages),
          pageParams: data.pageParams,
        };
      },
      enabled: enabled && !!keyword && keyword.length > 0 && !!latitude && !!longitude,
    }
  );

  return {
    hospitalData,
    isHospitalLoading,
    hasHospitalNextPage,
    fetchHospitalNextPage,
  };
};

export default useGetKeywordSearchHospitalInfinite;
